import { faEnvelope, faPhone } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './ContactCard.module.scss';

export default function ContactCard(props) {
    return (
        <>
            <div
                styleName={`contact-card ${props.blueGray ? 'blue-gray' : ''}`}
            >
                {props.noImage ? null : (
                    <div styleName="image-wrapper">
                        <img src="/images/laura.png" alt="Laura Romme" />
                    </div>
                )}
                <div styleName="info">
                    <div styleName="top">
                        <div styleName={`right ${props.big ? 'big' : ''}`}>
                            <p styleName="name">Laura Romme</p>
                            <p styleName="title">Adviseur onderwijsloket</p>
                        </div>
                    </div>
                    <hr />
                    <div styleName={`bottom ${props.big ? 'big' : ''}`}>
                        <a href="tel:0413283090" styleName="item">
                            <FontAwesomeIcon icon={faPhone} />
                            <p>0413 283090</p>
                        </a>
                        {/* <div styleName="item">
                        <FontAwesomeIcon icon={faIslandTropical} />
                        <p>Vakantie: 19-07-21 t/m 22-08-21</p>
                    </div> */}
                        <a
                            href="mailto:info@grijpjekansinhetonderwijs.nl"
                            styleName="item"
                        >
                            <FontAwesomeIcon icon={faEnvelope} />
                            <p>info@grijpjekansinhetonderwijs.nl</p>
                        </a>
                        {/* <a
                            styleName="item"
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.google.com/maps/place/Boxmeer/@51.6474548,5.8994735,13z/data=!3m1!4b1!4m5!3m4!1s0x47c713081f0cb315:0xd9e89c67006fe458!8m2!3d51.6452689!4d5.9566657"
                        >
                            <FontAwesomeIcon icon={faMapMarkedAlt} />
                            <p>Boxmeer</p>
                        </a> */}
                    </div>
                </div>
            </div>
        </>
    );
}
